import * as React from 'react';
import { createContext, useContext } from 'react';
import { OscarThemeClasses, getOscarTheme } from '../constants/AIAgentTheme';

/**
 * The role the AI surface should theme itself for.
 *
 * This must be the **session's** `userType`, not `CURRENT_ENV_ROLE_TYPE`: that
 * constant defaults to SUPPLIER whenever `REACT_APP_CURRENT_ENV_ROLE_TYPE` is
 * unset, so a plain `yarn start` reports supplier no matter who is signed in —
 * which rendered a cyan launcher on a buyer's purple app.
 */
const OscarRoleContext = createContext<string>(undefined);

interface OscarRoleProviderProps {
	/** `state.session.userType` — supply it with the `withUserType` HOC. */
	userType: string;
	children: React.ReactNode;
}

export const OscarRoleProvider = ({ userType, children }: OscarRoleProviderProps) => (
	<OscarRoleContext.Provider value={userType}>{children}</OscarRoleContext.Provider>
);

/**
 * Theme classes for the current role. Outside a provider it falls back to the
 * build role, so isolated usage still renders something sane.
 */
export const useOscarTheme = (): OscarThemeClasses => getOscarTheme(useContext(OscarRoleContext));

/** The active role, or undefined outside a provider. */
export const useOscarRole = (): string => useContext(OscarRoleContext);

export default OscarRoleContext;
